
import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

const CSRF_SAFE_METHODS = ["GET", "HEAD", "OPTIONS", "TRACE"];

function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (CSRF_SAFE_METHODS.includes(request.method.toUpperCase())) {
      return next.handle(request);
    }
    const token = getCsrfToken();
    if (token) {
      request = request.clone({ setHeaders: { "X-XSRF-TOKEN": token } });
    }
    return next.handle(request);
  }
}
